module.exports = __webpack_public_path__ + "static/media/no-posts-found.3d4ec7b0.png";